import React from 'react';

interface HelloWorldButtonProps {
    onClick: () => void;
    text: string;
}

const HelloWorldButton: React.FC<HelloWorldButtonProps> = ({ onClick, text }) => {
    return (
        <button onClick={onClick}>{text}</button>
    );
};

export default HelloWorldButton;